import './Loader.css';
function Loader() {
	return (
		<div className='loader'>
			<div className='line'></div>
			<div className='line'></div>
			<div className='line'></div>
			<div className='line'></div>
			<div className='line'></div>
		</div>
	);
}
export default Loader;
